<template>
  <!-- 分页器 -->
  <div class="PagingDevice ">
    <el-row>
        <!-- 只在sm及以上隐藏 -->
      <el-col :xs="22"
        :sm="6" :offset="1" class="hidden-sm-and-up">
        <el-pagination
          background
          :page-size="8"
          :pager-count="5"
          layout="prev, pager, next"
          :total="pageNum"
          next-text="下一页"
          prev-text="首页"
          @click="prev-click"
        >
        </el-pagination>
      </el-col>
        <!-- 只在xs隐藏 -->

      <el-col :xs="24"
        :sm="5" :offset="10" class="hidden-xs-only">
        <el-pagination
          background
          :page-size="8"
          :pager-count="5"
          layout="prev, pager, next"
          :total="pageNum"
          next-text="下一页"
          prev-text="首页"

        >
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    pageNum: Number,
  },
  components: {},
  data() {
    return {};
  },
  created: function () {},
  methods: {
      
  },
};
</script>

<style scoped>
.PagingDevice {
  /* margin: 0 auto; */
  margin-top: 50px;
  padding-bottom: 40px;
  /* border-bottom: solid 1px #dcdcdc; */
}
.el-pagination {
  /* margin: 0 auto; */
}
/* // 进行修改未选中背景和字体 */
.PagingDevice .el-pagination.is-background .el-pager li:not(.disabled) {
    background-color: #fff;   
    color: #fff;
}
/* // 进行修改选中项背景和字体 */
.PagingDevice .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #FF8200 !important;   
    color: #fff;
}

</style>